import {Component, OnInit, HostListener, OnDestroy} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {first} from 'rxjs/operators';
import {AlertService} from '../../services/alert.service';
import {AuthenticationService} from '../../services/authentication.service';
import {MessageService} from '../../services/message.service';
import {OapStandarErrorStateMatcher, errorMessages, OapErrorMessages} from '../../modules/custom-validators/custom-validators.module';
import {MatDialog} from '@angular/material';
import {ViewTextesLegauxComponent} from '../../modules/textes-legaux/view-textes-legaux/view-textes-legaux.component';
import {TrackingService} from '../../services/tracking.service';

@Component({
    selector: 'oap-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})

export class LoginComponent implements OnInit, OnDestroy {
    loginForm: FormGroup;
    loading = false;
    submitted = false;

    matcher = new OapStandarErrorStateMatcher();
    errors = errorMessages;
    validation_messages = OapErrorMessages;

    constructor(
        public dialog: MatDialog,
        private messageService: MessageService,
        private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private router: Router,
        private authenticationService: AuthenticationService,
        private alertService: AlertService,
        private tracking: TrackingService) {
    }

    ngOnInit() {

        this.loginForm = this.formBuilder.group({
            login: ['', Validators.compose([Validators.required, Validators.maxLength(256)])],
            mdp: ['', Validators.required]
        });
        this.messageService.sendMessage('page-login');
        this.authenticationService.logout();
        const element = document.getElementById('scrollWrapper');
        element.classList.add('wrapperLogged');
        this.tracking.DataLayer('/app', 'Homepage', '', '');
    }

    ngOnDestroy() {
        const element = document.getElementById('scrollWrapper');
        element.classList.remove('wrapperLogged');
    }
    
    onFormSubmit(form: FormGroup) {

        this.submitted = true;
        this.alertService.clear();
        if (form.invalid) {
            return;
        }

        this.loading = true;
        this.authenticationService.login(form.controls.login.value, form.controls.mdp.value)
            .pipe(first())
            .subscribe(
                data => {
                    const typeCompte = data.type;
                    if (typeCompte === 'A' || typeCompte === 'G' || typeCompte === 'T' || typeCompte === 'V') {
                        if (data.token) {
                            // store user details and jwt token in local storage to keep user logged in between page refreshes
                            this.tracking.pushDataLayer('Acces portail', 'Click', 'Connection valide');
                            if (typeCompte === 'A') {
                                this.router.navigate(['/admin']);
                            } else if (typeCompte === 'G' || typeCompte === 'T' || typeCompte === 'V') {
                                this.router.navigate(['/backoffice']);
                            }
                        }
                    }  else {
                        const ret = this.cguOk(parseInt(data.id), data.otpInfo.type);
                    }
                },
                error => {
                    console.log('login - error ', error);
                    this.alertService.error('Connexion impossible, ' + error, true);
                    this.tracking.pushDataLayer('Acces portail', 'Click', 'Connection invalide');
                    this.loading = false;
                });

    }

    @HostListener('window:keyup.enter', ['$event', 'undefined'])
    @HostListener('window:click', ['undefined', '$event'])
    onEnterOrClick(enterEvent, mouseEvent) {
        this.alertService.clear();
    }


    cguOk(authTokenId: number, typeEnvoiOtp: string) {
        const validationCGU = JSON.parse(localStorage.getItem('validation-cgu'));

        if (validationCGU === 'true') {
            const dialogRef = this.dialog.open(ViewTextesLegauxComponent,
                {
                    disableClose: true,
                    data: {typeTexte: 'cgu'}
                });

            dialogRef.afterClosed().subscribe(result => {
                if (result === 'true') {
                    // cgu validé
                    localStorage.setItem('validation-cgu', 'false');
                    this.tracking.pushDataLayer('Acces portail', 'Click', 'Connection valide');
                    this.router.navigate(['/']);
                } else {
                    return null;
                }
            });
        } else {
            // cgu déjà validé
            this.tracking.pushDataLayer('Acces portail', 'Click', 'Connection valide');
            this.router.navigate(['/']);
        }
    }

}
